import { Button } from '@benzinga/core-ui';
import { SmartLink } from '@benzinga/analytics';
import styled from '@benzinga/themetron';
import { Event } from '@benzinga/events-manager';

interface IProps {
  event: Event;
}

const FusionEventCard = ({ event }: IProps) => {
  return (
    <Card>
      <Header>
        <ImageBox url={event?.acf?.marketing_image as string} />
      </Header>
      <Content>
        <Title dangerouslySetInnerHTML={{ __html: event?.title?.rendered }} />
        <DateAndLocation>{event?.acf?.date_and_location}</DateAndLocation>
      </Content>
      <Footer>
        <SmartLink className="event-link" href={event?.acf?.learn_more}>
          <Button className="event-button" size="fusion-md" variant="fusion-secondary">
            LEARN MORE
          </Button>
        </SmartLink>
      </Footer>
    </Card>
  );
};

const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorPalette.white};
  border: 1px solid ${({ theme }) => theme.colorPalette.gray200};
  box-shadow: 0 2px 8px rgba(55, 84, 113, 0.04);
  border-radius: 4px;
  overflow: hidden;
  transition: 0.25s box-shadow ease-in-out;

  &:hover {
    box-shadow: 0 2px 16px rgba(25, 68, 128, 0.1);
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colorPalette.gray800};
  height: 140px;
  padding: 16px;
`;

const ImageBox = styled.div<{ url: string }>`
  background-image: url(${({ url }) => url});
  background-origin: content-box;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 100%;
  width: 100%;
`;

const Content = styled.div`
  flex: 1;
  padding: 16px 16px 30px;
  background-color: ${({ theme }) => theme.colorPalette.white};
`;

const DateAndLocation = styled.div`
  font-size: ${({ theme }) => theme.fontSize.base};
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  line-height: 20px;
  color: ${({ theme }) => theme.colorPalette.gray500};
  margin-top: 12px;
`;

const Title = styled.h6`
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  line-height: 20px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colorPalette.gray700};
`;

const Footer = styled.div`
  display: flex;
  padding: 0 16px 16px;

  & .event-link {
    flex: 1;
  }

  & .event-button {
    width: 100%;
    white-space: nowrap;
  }
`;

export default FusionEventCard;
